<template>
  <div class="modal-card-body">
    <p v-html="verbiage.introduction_paragraph"></p>
  </div>
</template>

<script>
import { watch, onMounted } from 'vue'
import { useConfig } from '@/composables/useConfig'

export default {
  emits: ['set-title', 'reset', 'set-next-button-label', 'set-next-route', 'set-prev-route', 'set-show-prev', 'set-show-next'],
  props: {
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { verbiage } = useConfig()

    watch(
      verbiage,
      (newVerbiage) => {
        if (newVerbiage.introduction_title) {
          emit('set-title', newVerbiage.introduction_title)
        }
      },
      { immediate: true }
    )

    onMounted(() => {
      emit('reset')
      emit('set-next-button-label', 'Next Step')
      emit('set-next-route', '/flow/address-search')
      emit('set-prev-route', null)
      emit('set-show-prev', false)
      emit('set-show-next', true)
    })

    return {
      verbiage
    }
  }
}
</script>

<style scoped>
/* Add your styles here */
</style>
